import React, { Component } from 'react';
import GetLogin from './getLogin';
import GetDashboard from './getDashboard';
import '../css_generales/getHomeUser.css';
import 'whatwg-fetch';
class getHomeUser extends Component {
  constructor(props){
    super(props);
    this.state = {
        token_User:'',
        uuid_agente:'',
        agente_nombre:'',
        modulo:'',
        msg_loading:false,
        id_sucursal:0,
        usuario:'',
        sucursal:'',
        id_tipo_permiso:0,
        hora_apertura:'',
        hora_cierre:'',
        uuid_imagen:'',
        uuid_sucursal:'',
        validate:false
    }
    //console.log(this.props.token)
  }
  cargar_user =()=>{

    const token_User = localStorage.getItem('TOKEN_USER'+this.props.database)//localStorage.TOKEN_USER
    const TOKEN_AGENTE = localStorage.getItem('TOKEN_AGENTE'+this.props.database)//localStorage.TOKEN_USER
    const TOKEN_UUIDAGENTE = localStorage.getItem('TOKEN_UUIDAGENTE'+this.props.database)//localStorage.TOKEN_USER

    if(token_User){
      var dt = new Date()
      const dia =dt.getUTCDay()
      const url= this.props.dir_url + "webapp/getValite_U_getUser";
      const token =  this.props.token


      var obj = { accion:'validateUgetuser', token, token_User,dia};
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(obj),
        headers:{
          'Accept':'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(res => res.json())
      .then((data) => {
        if(data[0].status==="ok"){
          //console.log(data[0].msg[0].uuid_usuario+'aaaaaaaaaaaaaaaaaaaaaaaaaaaa')
          this.setState({
            modulo:'dashboard',
            token_User:data[0].msg[0].uuid_usuario,
            id_sucursal:data[0].msg[0].id_sucursal,
            usuario:data[0].msg[0].usuario,
            sucursal:data[0].msg[0].sucursales,
            id_tipo_permiso:data[0].msg[0].id_tipo_permiso,
            hora_apertura:data[0].msg[0].hora_apertura,
            hora_cierre:data[0].msg[0].hora_cierre,
            uuid_agente:TOKEN_AGENTE,
            agente_nombre:TOKEN_UUIDAGENTE
          },()=>{
            this.get_loading(false)
          })
        }else{
          this.get_loading(false)
        }
      })
      .catch(console.log)
      this.get_loading(true)
    }else{
      this.setState({
        modulo:'login'
      })
    }
  }
  setCerrarSesion =()=>{
    //localStorage.TOKEN_USER=""
    localStorage.removeItem('TOKEN_USER'+this.props.database);
    localStorage.removeItem('TOKEN_AGENTE'+this.props.database);
    localStorage.removeItem('TOKEN_UUIDAGENTE'+this.props.database);
    window.location.reload(false)
  }
  get_asignarse_pedido =(token_pedido,token_User)=>{
    const url= this.props.dir_url + "webapp/get_pedido_motorizado";
    const token =  this.props.token
    var obj = { accion:'pedidomotorizado', token, token_pedido,token_User};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      this.get_loading(false)
    })
    .catch(console.log)
    this.get_loading(true)
  }

  setAbrirCaja =(token_User)=>{
    const url= this.props.dir_url + "webapp/getValite_U_getBilleteraA";
    const token =  this.props.token
    var obj = { accion:'validateUgetbilleteraA', token, token_User};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      this.get_loading(false)
    })
    .catch(console.log)
    this.get_loading(true)
  }
  setCerrarCaja=(token_User)=>{
    const url= this.props.dir_url + "webapp/getValite_U_getBilleteraC";
    const token =  this.props.token
    var obj = { accion:'validateUgetbilleteraC', token, token_User};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      this.get_loading(false)
    })
    .catch(console.log)
    this.get_loading(true)
  }


  setTokenusuario =(token_Usuario,uuid_agente,agente_nombre)=>{
    //localStorage.TOKEN_USER = token_Usuario
    localStorage.setItem('TOKEN_USER'+this.props.database,token_Usuario);
    localStorage.setItem('TOKEN_AGENTE'+this.props.database,uuid_agente);
    localStorage.setItem('TOKEN_UUIDAGENTE'+this.props.database,agente_nombre);
    window.location.reload(false)
  }
  get_loading =(msg_loading)=>{
    this.setState({
      msg_loading
    })
  }
  buscarTheme =()=>{
    const url= this.props.dir_url + "webapp/getTheme";
    const token =  this.props.token

    var obj = { accion:'theme', token };
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {

      if(data[0].status==="ok"){
        document.documentElement.style.setProperty("--color-primario", data[0].__color_primario);
        document.documentElement.style.setProperty("--color-secundario", data[0].__color_secundario);
        document.documentElement.style.setProperty("--color_terciario", data[0].__color_terciario);
        document.documentElement.style.setProperty("--logo_general", data[0].__logo_general);
        document.documentElement.style.setProperty("--color_fondo_letra", data[0].__color_fondo_letra);
        document.documentElement.style.setProperty("--color_lineas", data[0].__color_lineas);
        document.documentElement.style.setProperty("--color_letras", data[0].__color_letras);
        this.setState(
          {
            uuid_imagen:data[0].uuid_imagen,
            uuid_sucursal:data[0].uuid_sucursal,
            validate:true
          }
        )
      }
    })
    .catch(console.log)
  }
  render() {
    let modal_loading
    let validate = this.state.validate
    const msg_loading = this.state.msg_loading
    if(msg_loading){
      modal_loading = <div id="loader" className="loader loader-default is-active" data-text=""></div>
    }
    let dir_modulo
    const modulo = this.state.modulo
    if(modulo==='login'){

      dir_modulo = <GetLogin separator={this.props.separator} url_image={this.props.url_image}  get_loading={this.get_loading} setTokenusuario={this.setTokenusuario} file_250x200={this.props.file_250x200} token={this.props.token} dir_url={this.props.dir_url} token_User={this.state.token_User} uuid_imagen={this.state.uuid_imagen}/>
    }
    if(modulo==='dashboard'&&validate===true){
      dir_modulo = <GetDashboard database={this.props.database} get_asignarse_pedido={this.get_asignarse_pedido} uuid_sucursal={this.state.uuid_sucursal} separator={this.props.separator} url_image={this.props.url_image}  firebase={this.props.firebase} file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_250x250={this.props.file_250x250} file_60x60={this.props.file_60x60} hora_apertura={this.state.hora_apertura} hora_cierre={this.state.hora_cierre} id_tipo_permiso={this.state.id_tipo_permiso} setCerrarSesion={this.setCerrarSesion} setAbrirCaja={this.setAbrirCaja} setCerrarCaja={this.setCerrarCaja} sucursal={this.state.sucursal} usuario={this.state.usuario} id_sucursal={this.state.id_sucursal} get_loading={this.get_loading} setTokenusuario={this.setTokenusuario} token={this.props.token} dir_url={this.props.dir_url} uuid_agente={this.state.uuid_agente} agente_nombre={this.state.agente_nombre} token_User={this.state.token_User}/>
    }

    return (
      <React.Fragment>
      <div className="cssversion_menu cssversion_colorblanco">
        <div className="cssversion_pw100 cssversion_ph10 cssversion_contentCenter" style={{"display":"flex"}}>
          <span className="span-tmp"><img style={{"height":"60px"}}  alt="Cargando Imagen . . ." src="https://elasesorpublico.com/neola/ticket/img/logos/1718002924001.png" /></span>
        </div>
        <div className="cssversion_pw100 cssversion_ph90" style={{"display":"flex"}}>
          {dir_modulo}
        </div>
        {modal_loading}
      </div>
      </React.Fragment>
    )
  }
/*<div className="lbl_contenedor_usuario">
  <div className="grid-container-U_Login">
    <div className="div_1_U">
        <img style={{"height":"60px"}}  alt="Cargando Imagen . . ." src="https://elasesorpublico.com/neola/ticket/img/logos/1718002924001.png" />
    </div>
    <div className="div_2_U">
      {dir_modulo}
    </div>

  </div>
</div>*/
  componentDidMount (){
    this.cargar_user()
    this.buscarTheme()
  }

}
export default getHomeUser;
